










import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import links from '@/data/links'

const siteModule = namespace('site')

@Component
class LcNavDrawer extends Vue {
  @siteModule.State('showDrawer') showDrawer: any
  @siteModule.Action('setDrawerDisplay') setDrawerDisplay: any

  get drawerShown () {
    return this.showDrawer
  }

  set drawerShown (newState: boolean) {
    this.setDrawerDisplay(newState)
  }

  links = links
}
export default LcNavDrawer
